import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment'
import { Performer} from 'src/app/store/performers.era';
import { JoiFile } from 'globals/store/files.model';
import { Session } from 'src/app/store/programs.era';
import { SynopsisReturnData } from 'globals/store/share.data';
import { ShareWrapper } from './share-wrapper.component';
import { BrandingData } from 'globals/store/publish.data';
import { MutatingInputComponent } from 'src/app/components/joi-input/mutating-input.component';
import { CommonModule } from '@angular/common';
import { Subject } from 'rxjs';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { InputEditorComponent } from 'src/app/components/joi-input/input-editor';
import { BrandingWrapperComponent } from 'src/app/components/branding/branding-wrapper.component';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'share-session-synopsis',
    template: ` 
<branding-wrapper 
  [brandingData]="brandingData" 
  [style.--sitebackground]="brandingData?.template?.sitebackground || '#ffffff'">
  <div class="share-session-synopsis">
    <div *ngIf="loading" class="loading">Loading...</div>
    <div *ngIf="!loading && !eventTitle"  class="sorry" [innerHTML]="helpers.strWithBreak(inactiveMessage)"></div>
    <div *ngIf="submitted"  class="thanks" [innerHTML]="helpers.strWithBreak(resultMessage)"></div>
    <div class="container synopsis" *ngIf="eventTitle && !submitted">
      <h1 class="center">{{ eventTitle }}</h1>
      <h3 class="center">{{ programName }}</h3>
      <div class="center">{{ sessionDateTime.primary }}</div>
      <div class="secondaryTime center" *ngIf="sessionDateTime.secondary">({{ sessionDateTime.secondary }})</div>
      <div class="instructions">
        Please review/supply the following session information.
      </div>
      <div class="fields">
        <mutating-input class="title-input" [object]="session" [prop]="'title'" placeholder="Session title"></mutating-input>
        <!--<mutating-input [object]="session" [prop]="'description'" placeholder="Session description" [isArea]="true" [areaMinRows]="5" ></mutating-input>
  -->       
        <input-editor 
          class="placeholder-no-italics"
          [object]="session" 
          [prop]="'description'" 
          [forceSave]="forceSave"
          [placeholder]="'Click to add description...'"
        ></input-editor>

      </div>
      <div class="public_files">
        <h3><icon class="link_icon" icon="link18"></icon>Public links</h3> 
        <div *ngIf="!session.publicLinks?.length" class="notice">
          No public links in this session
        </div>
        <div class="asset" *ngFor="let link of session.publicLinks; index as index" >
        <h4>Public link</h4>
          <mutating-input 
            [object]="link" 
            prop="filename" 
            placeholder="Title"
            (textChange)="checkValidity()"
          ></mutating-input>
          <mutating-input 
            [object]="link" 
            prop="linkUrl" 
            placeholder="Full URL (Must start with http or https)"
            (textChange)="checkValidity()"
          ></mutating-input>
          <div class="delete_btn" (click)="deleteAsset(index)"><icon icon="delete18"></icon></div>
        </div>
        <div class="add_btn" (click)="addMoreAssets()">
          + ADD A LINK
        </div>
      </div>
      <div class="note">
        Note: This form will be deactivated after you submit.
      </div>
      <button mat-button color="primary" (click)="submit()" [disabled]="processing || disabled" >
        <div class="button_content">
          Submit
        </div>
      </button>
      <div class="error-holder" *ngIf="error" [innerHTML]="helpers.strWithBreak(error)"></div>
    </div>
  </div>
</branding-wrapper>
    `,
    styleUrls: ['./share.editPerformer.scss'],
    styles: [`
  mutating-input.title-input { display: block; margin-bottom: -10px; }
`],
    standalone: true,
    imports: [MutatingInputComponent, MatButtonModule, CommonModule, IconComponent, InputEditorComponent, BrandingWrapperComponent],
})
export class ShareSessionSynopsisComponent extends ShareWrapper<ShareSessionSynopsisComponent> {

    readonly api = `${environment.functionsURL}api/v1`; // NOTE this is pointing to api/v1 not api/app
    id:string;
    loading = true;
    processing:boolean;
    disabled = false;
    submitted:boolean;
    eventId;
    eventTitle;
    session:Partial<Session> = {};
    performerName;
    programName;
    sessionDateTime;
    submitterForAnyone = { name: '' }
    resultMessage = "Thank you"
    inactiveMessage = "Session information submission area is currently not available.\n\nPlease contact the event organiser."
    cannotSubmitMessage = "The session information can't be submitted at this time.\n\nPlease reload this page and try again."
    performer:Performer
    brandingData: BrandingData
    forceSave: Subject<void> = new Subject<void>();

    constructor(private route:ActivatedRoute) {
      super()
      this.loading = true;
      document.title = "loading";
      this.route.params.subscribe(params=>{
        if(!params || !params.hasOwnProperty('id')) {
          this.loading = false;
          document.title = "Unavailable";
        } else {
          this.id = params.id;
          const url = `${this.api}/load-session-synopsis`
          try {
            this.take1(this.http.post(url, { id:this.id })).then((data: SynopsisReturnData) => {
              this.loading = false;
              this.eventTitle = data.eventTitle
              this.session.title = data.sessionTitle
              this.session.description = data.sessionDescription
              this.session.publicLinks = data.publicLinks || []
              this.sessionDateTime = data.sessionDateTime
              this.programName = data.programName
              this.eventId = data.eventId
              this.performerName = data.performerName
              this.brandingData = data.brandingData
              document.title = "Add information for this session";
              // this.addMoreAssets();      
            }, (error) => {
              console.error({ error })
              document.title = "Not available"
              this.loading = false;
              document.title = "Unavailable"
            })
          }catch(error){
            console.error({ error })
            document.title = "Unavailable"
            this.loading = false;
          }
        }
      })
    }
    
    addMoreAssets(){
      this.session.publicLinks.push(this.getFreshFile())
      this.disabled = true
    }

    checkValidity() {
      this.disabled = 
        (this.session.publicLinks.some(asset => !asset.filename || !asset.linkUrl || !this.helpers.urlOk(asset.linkUrl)))
    }

    deleteAsset(index){
      this.session.publicLinks.splice(index, 1);
      this.checkValidity()
    }

    getFreshFile(): JoiFile{
      return {
        filename:'',
        linkUrl:'',
        created: (new Date()).getTime(),
      }
    }

    addPublicLinks(publicLinks){
      this.session.publicLinks = publicLinks;
    }

    submit(){
      this.processing = true;
      this.forceSave.next();
      setTimeout(() => {
        const url = `${this.api}/submit-session-synopsis-with-code-data`
        this.take1(this.http.post(url, {
          id:this.id,
          publicLinks: this.session.publicLinks || null,
          title:this.session.title || null,
          description:this.session.description || null,
        })).then((data:any) => {
          this.processing = false;
          this.submitted = true;
          if (data.error) {
            this.resultMessage = "Session information can't be submitted at this time.\n\nPlease reload this page and try again."
          }
        }, error => {
          console.error({ error })
          this.processing = false;
          this.showError(this.cannotSubmitMessage)
        });
      }, 100)
    }
}

